import React, { SetStateAction, useEffect, useState } from "react";
interface Props {
  accountName: string;
  userId: string;
  categories: string[];
  updateSelectedOrderGuides: (userId: string, category: string, checked: boolean) => void;
  selectedOrderGuides: {
    [index: string]: {
      checked: boolean;
      category: string;
    };
  };
  checkAll: boolean;
  disabled: boolean;
  setYourAccountCategory?: React.Dispatch<SetStateAction<string>>;
  removeApplyAll?: () => void;
  isInRemoveCheckAllEvent: boolean;
}
export default ({
  accountName,
  userId,
  categories,
  updateSelectedOrderGuides,
  checkAll,
  disabled,
  setYourAccountCategory,
  removeApplyAll,
  isInRemoveCheckAllEvent
}: Props) => {
  const [checked, setChecked] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const selectedCategory = newCategory || categories[0] || "";

  // Update local checked to match checkAll whenever checkAll is updated
  useEffect(() => {
    if (!isInRemoveCheckAllEvent) {
      setChecked(checkAll);
    }
  }, [checkAll, isInRemoveCheckAllEvent]);
  useEffect(() => {
    if (setYourAccountCategory) {
      setYourAccountCategory(selectedCategory);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);
  const handleCheckboxInputOnChange = () => {
    if (checkAll) {
      if (removeApplyAll) {
        removeApplyAll();
      }
    }
    setChecked(!checked);
    updateSelectedOrderGuides(userId, selectedCategory, !checked);
  };
  const handleDropdownChanged = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setNewCategory(event.target.value);
    updateSelectedOrderGuides(userId, event.target.value, checked);
  };
  const handleInputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewCategory(event.target.value.trim());
    updateSelectedOrderGuides(userId, event.target.value.trim(), checked);
  };
  return <>
      <div className="guide-add__section">
        <div className="form__multiselect-container">
          <div className="form__multiselect-element">
            <input type="checkbox" className="form__multiselect-input" id={`addTo${userId}`} data-testid={`order-guide-checkbox-${userId}`} onChange={handleCheckboxInputOnChange} checked={checked} />
            <label htmlFor={`addTo${userId}`} className="form__check form__multiselect" />
          </div>
          <label htmlFor={`addTo${userId}`} className="form__multiselect-text">
            {accountName}
          </label>
        </div>
      </div>
      <div className="guide-add__section" data-testid={`existing-order-guide-container-${userId}`}>
        {categories?.length > 0 && <>
            <label>Add Item to</label>
            <div className={`form__control-container${disabled ? " disabled" : ""}`}>
              <select className="form__control" onChange={handleDropdownChanged} data-testid={`existing-order-guide-dropdown-${userId}`}>
                {categories.map(category => <option value={category} key={category}>
                    {category}
                  </option>)}
              </select>
              <label className="form__label">Choose Guide</label>
              <i className="icon-down-micro form__control-icon form__control-icon--lg" />
            </div>
          </>}
      </div>
      <div className="guide-add__section" data-testid={`new-order-guide-container-${userId}`}>
        <label>Add Item to New Guide</label>
        <div className={`form__control-container${disabled ? " disabled" : ""}`}>
          <input type="text" className="form__control" placeholder="Guide Name" onChange={handleInputChanged} disabled={disabled} data-testid={`new-order-guide-input-${userId}`} />
          <label className="form__label">Guide Name</label>
        </div>
      </div>
    </>;
};